export default __webpack_public_path__ + "static/media/queue_seat_decrease.517db7f7.svg";